import CodeMirror from 'codemirror'
import 'codemirror/mode/xml/xml.js'
import 'codemirror/mode/css/css.js'
import 'codemirror/mode/javascript/javascript.js'
import 'codemirror/addon/selection/active-line.js'
import 'codemirror/addon/edit/matchbrackets.js'
import 'codemirror/addon/fold/foldcode.js'
import 'codemirror/addon/fold/foldgutter.js'
import 'codemirror/addon/fold/brace-fold.js'
import 'codemirror/addon/fold/xml-fold.js'

export default Vue.extend({
  props: {
    value: {
      type: String,
      default: ''
    },
    name: {
      type: String,
      required: true
    },
    label: {
      type: String,
      required: true
    },
    mode: {
      type: String,
      required: true
    }
  },

  data() {
    return {
      editor: null
    }
  },

  mounted() {
    this.editor = CodeMirror.fromTextArea(this.$refs.textarea, {
      theme: 'twilight',
      mode: this.mode,
      lineNumbers: true,
      matchBrackets: true,
      styleActiveLine: true,
      tabSize: 2,
      foldGutter: true,
      gutters: ['CodeMirror-linenumbers', 'CodeMirror-foldgutter']
    })
    this.editor.on('change', (editor) => {
      this.$emit('input', editor.getValue())
    })
  },

  beforeDestroy() {
    if (this.editor) {
      this.editor.toTextArea()
      this.editor = null
    }
  },

  watch: {
    value(next) {
      if (this.editor && this.editor.getValue() !== next) {
        this.editor.setValue(next || '')
      }
    }
  },

  template: `
    <div class="template-code-editor">
      <label class="form-label">{{ label }}</label>
      <textarea
        ref="textarea"
        class="controlled-input"
        rows="10"
        :name="name"
        :value="value"
      ></textarea>
    </div>
  `
})
